/**
 * Decathlon IP geolocation helpers.
 * - Poland (PL) IP: show redirect CTAs, hide geo-filtered listing cards / purchase UI
 * - Non-Poland IP: show add-to-cart CTAs, show geo-filtered listing cards
 * Does not use Shopify localization.country.iso_code.
 */
(function () {
  var GEO_STORAGE_KEY = "decathlon_geo_country";
  var GEO_CACHE_MS = 6 * 60 * 60 * 1000;
  var HIDDEN_CLASS = "decathlon-geo--hidden";

  function getCachedCountry() {
    try {
      var raw = sessionStorage.getItem(GEO_STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.country || !parsed.ts) return null;
      if (Date.now() - parsed.ts > GEO_CACHE_MS) return null;
      return String(parsed.country).toUpperCase();
    } catch (e) {
      return null;
    }
  }

  function setCachedCountry(country) {
    try {
      sessionStorage.setItem(
        GEO_STORAGE_KEY,
        JSON.stringify({ country: country, ts: Date.now() }),
      );
    } catch (e) {}
  }

  function detectCountryByIp() {
    return fetch("https://api.country.is/", { credentials: "omit" })
      .then(function (res) {
        if (!res.ok) throw new Error("country.is failed");
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.country) throw new Error("missing country");
        return String(data.country).toUpperCase();
      })
      .catch(function () {
        return fetch("https://get.geojs.io/v1/ip/country.json", {
          credentials: "omit",
        })
          .then(function (res) {
            if (!res.ok) throw new Error("geojs failed");
            return res.json();
          })
          .then(function (data) {
            if (!data || !data.country) throw new Error("missing country");
            return String(data.country).toUpperCase();
          });
      });
  }

  function syncDecathlonCtas(isPoland) {
    document.querySelectorAll('[data-decathlon-cta="redirect"]').forEach(function (el) {
      el.classList.toggle("decathlon-cta--hidden", !isPoland);
      el.classList.toggle(HIDDEN_CLASS, !isPoland);
    });
    document.querySelectorAll('[data-decathlon-cta="cart"]').forEach(function (el) {
      el.classList.toggle("decathlon-cta--hidden", isPoland);
      el.classList.toggle(HIDDEN_CLASS, isPoland);
    });
  }

  function syncListingVisibility(isPoland) {
    document.querySelectorAll('[data-decathlon-geo-item="hide-in-pl"]').forEach(function (el) {
      var exempt = el.closest("[data-decathlon-collection-page]");
      if (exempt) {
        el.classList.remove(HIDDEN_CLASS);
        return;
      }
      el.classList.toggle(HIDDEN_CLASS, isPoland);
    });

    document.querySelectorAll("[data-decathlon-geo-purchase]").forEach(function (el) {
      var exempt = el.closest("[data-decathlon-collection-page]");
      if (exempt) {
        el.classList.toggle(HIDDEN_CLASS, isPoland);
        return;
      }
      el.classList.toggle(HIDDEN_CLASS, isPoland);
    });
  }

  function applyCountry(countryCode) {
    var isPoland = countryCode === "PL";
    document.documentElement.setAttribute(
      "data-decathlon-geo",
      isPoland ? "PL" : "INTL",
    );
    syncDecathlonCtas(isPoland);
    syncListingVisibility(isPoland);
    document.dispatchEvent(
      new CustomEvent("decathlon:geo", { detail: { country: countryCode, isPoland: isPoland } }),
    );
  }

  function refresh() {
    var geo = document.documentElement.getAttribute("data-decathlon-geo");
    if (geo === "PL") {
      syncDecathlonCtas(true);
      syncListingVisibility(true);
    } else if (geo === "INTL") {
      syncDecathlonCtas(false);
      syncListingVisibility(false);
    }
  }

  window.DecathlonGeo = {
    refresh: refresh,
    applyCountry: applyCountry,
  };

  var cached = getCachedCountry();
  if (cached) {
    applyCountry(cached);
  } else {
    detectCountryByIp()
      .then(function (country) {
        setCachedCountry(country);
        applyCountry(country);
      })
      .catch(function () {
        // Keep geo-sensitive items hidden until we know the country.
      });
  }

  // Predictive search and other async UIs inject nodes after first paint.
  if (typeof MutationObserver !== "undefined") {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        refresh();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
